// @flow
import styled from 'styled-components';

export default styled.input`
  display: block;
  border: none;
  border-bottom: 2px solid ${props => props.theme.colors.black};
  font-size: 16px;
  padding: 10px 0;
  font-family: ${props => props.theme.fontBold};
  width: 100%;
  margin-bottom: 30px;
  transition: 0.3s ease;
  &:focus {
    border-bottom-color: ${(props: Rota$SCP) => props.theme.colors.green};
    outline: none;
  }
`;



// WEBPACK FOOTER //
// ./src/components/auth-page-layout/input.js